import { AuthTranslationType } from "../../features/auth.types";

export const auth: AuthTranslationType = {
  auth: {
    cookieConsent: {
      title: "Consentement aux Cookies",
      description: "Ce site utilise des cookies pour améliorer votre expérience de navigation. En cliquant sur 'Accepter', vous consentez à l'utilisation de cookies conformément à notre Politique de Cookies.",
      accept: "Accepter les Cookies",
      readMore: "Pour en savoir plus, veuillez lire notre ",
      privacyPolicy: "Politique de Confidentialité",
      and: "et",
      termsOfService: "Conditions d'Utilisation"
    },
    title: {
      resetPassword: "Réinitialiser le Mot de Passe",
      welcome: "Bienvenue"
    },
    form: {
      displayName: "Nom d'Affichage",
      email: "Email",
      password: "Mot de Passe",
      newPassword: "Nouveau Mot de Passe",
      forgotPassword: "Mot de passe oublié ?",
      loading: "Chargement...",
      signIn: "Se Connecter",
      signUp: "S'Inscrire",
      resetPassword: "Réinitialiser le Mot de Passe",
      sendResetLink: "Envoyer le Lien de Réinitialisation",
      alreadyHaveAccount: "Vous avez déjà un compte ? Se Connecter",
      needAccount: "Besoin d'un compte ? S'Inscrire",
      backToSignIn: "Retour à la Connexion",
      orContinueWith: "Ou continuer avec",
      google: "Google",
      facebook: "Facebook",
      privacyPolicyAgreement: "En cliquant sur S'Inscrire, vous acceptez",
      privacyPolicy: "Politique de Confidentialité",
      termsAgreement: "et",
      termsOfService: "Conditions d'Utilisation"
    },
    toast: {
      missingInfo: {
        title: "Informations Manquantes",
        description: "Veuillez fournir un email et un mot de passe."
      },
      missingName: {
        title: "Information Manquante",
        description: "Veuillez fournir un nom d'affichage."
      },
      invalidEmail: {
        title: "Email Invalide",
        description: "Veuillez entrer une adresse email valide."
      },
      invalidPassword: {
        title: "Mot de Passe Invalide",
        description: "Le mot de passe doit comporter au moins 6 caractères."
      },
      emailNotVerified: {
        title: "Email Non Vérifié",
        description: "Veuillez vérifier votre boîte de réception et cliquer sur le lien de confirmation pour vérifier votre email. Besoin d'un nouveau lien ?",
        resend: "Renvoyer"
      },
      verificationEmailSent: {
        title: "Email de Vérification Envoyé",
        description: "Veuillez vérifier votre boîte de réception pour le lien de confirmation."
      },
      loginFailed: {
        title: "Échec de la Connexion",
        description: "Email ou mot de passe invalide. Veuillez réessayer ou inscrivez-vous si vous n'avez pas de compte."
      },
      displayNameTaken: {
        title: "Nom d'Affichage Déjà Utilisé",
        description: "Ce nom d'affichage est déjà utilisé. Veuillez en choisir un autre."
      },
      signUpSuccess: {
        title: "Succès",
        description: "Vérifiez votre email pour le lien de confirmation !"
      },
      userAlreadyRegistered: {
        title: "Échec de l'Inscription",
        description: "Cet email est déjà enregistré. Veuillez essayer de vous connecter."
      },
      resetEmailSent: {
        title: "Vérifiez votre email",
        description: "Nous vous avons envoyé un lien de réinitialisation de mot de passe. Veuillez vérifier votre boîte de réception."
      },
      resetSuccess: {
        title: "Succès",
        description: "Votre mot de passe a été réinitialisé avec succès. Veuillez vous connecter avec votre nouveau mot de passe."
      },
      error: {
        title: "Erreur",
        description: "Une erreur inattendue s'est produite. Veuillez réessayer."
      },
      googleLoginError: {
        title: "Erreur de Connexion Google",
        description: "Impossible de se connecter avec Google. Veuillez réessayer."
      },
      facebookLoginError: {
        title: "Erreur de Connexion Facebook",
        description: "Impossible d'initialiser la connexion Facebook. Veuillez réessayer."
      },
      samePassword: {
        title: "Erreur",
        description: "Le nouveau mot de passe doit être différent de l'ancien."
      },
      agreementRequired: {
        title: "Accord Requis",
        description: "Vous devez accepter les conditions d'utilisation et la politique de confidentialité."
      },
    }
  }
};
